<template>
  <footer class="site-footer">
    <div class="container">
      <div class="footer-content">
        <!-- Left: Navigation columns -->
        <div class="nav-columns">
          <div v-for="(group, gIdx) in navGroups" :key="'group-' + gIdx" class="nav-group">
            <h4 class="nav-title" @click="toggleGroup(gIdx)">
              {{ group.title }}
              <span class="nav-arrow" :class="{ open: openGroups[gIdx] }">›</span>
            </h4>
            <ul class="nav-list" :class="{ open: openGroups[gIdx] }">
              <li v-for="(item, idx) in group.items" :key="'item-' + gIdx + '-' + idx" class="nav-item">
                <router-link :to="item.path || '#'" @click.native="closeAllGroups">{{ item.label }}</router-link>
              </li>
            </ul>
          </div>
        </div>

        <!-- Right: Contact and subscribe -->
        <div class="contact-side">
          <ul class="contact-list">
            <li class="contact-item">
              <img :src="icons.phone" class="icon" alt="phone" />
              <span class="text">{{ $t('footer.contact.sales') }}</span>
            </li>
            <li class="contact-item">
              <img :src="icons.email" class="icon" alt="email" />
              <span class="text">{{ $t('footer.contact.email') }}</span>
            </li>
            <li class="contact-item">
              <img :src="icons.local" class="icon" alt="local" />
              <span class="text">{{ $t('footer.contact.address') }}</span>
            </li>
          </ul>

          <div class="subscribe">
            <el-input v-model="subscribeInput" :placeholder="$t('footer.subscribePlaceholder')" class="subscribe-input" />
            <el-button class="subscribe-btn" type="warning" @click="subscribe">{{ $t('footer.subscribe') }}</el-button>
          </div>

          <div class="social">
            <a
              v-for="(s, i) in socials"
              :key="'s-' + i"
              :href="s.href"
              target="_blank"
              rel="noopener"
              class="social-item"
            >
              <img :src="s.src" :alt="s.type" class="social-icon" />
            </a>
          </div>
        </div>
      </div>

      <!-- Bottom: logo and ICP -->
      <div class="footer-bottom">
        <img src="@/assets/footer/logo.png" alt="logo" class="logo" />
        <span class="icp">{{ $t('footer.icp') }}</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
  data() {
    return {
      subscribeInput: '',
      openGroups: {},
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1200,
      socials: [
        { type: 'facebook', href: '#', src: require('../assets/footer/facebook.png') },
        { type: 'linkedin', href: '#', src: require('../assets/footer/link.png') },
        { type: 'instagram', href: '#', src: require('../assets/footer/ins.png') },
        { type: 'youtube', href: '#', src: require('../assets/footer/youtube.png') },
      ],
      icons: {
        phone: require('../assets/footer/phone.png'),
        email: require('../assets/footer/email.png'),
        local: require('../assets/footer/local.png'),
      },
    }
  },
  computed: {
    isMobile() {
      return this.windowWidth <= 768
    },
    navGroups() {
      return [
        {
          title: this.$t('nav.products'),
          items: [
            { label: this.$t('nav.smartFarm'), path: '/products/farm' },
            { label: this.$t('nav.smartHome'), path: '/products/home' },
            { label: this.$t('nav.smartTraffic'), path: '/products/traffic' },
            { label: this.$t('nav.smartFactory'), path: '/products/factory' },
            { label: this.$t('nav.course'), path: '/products/course' },
            { label: this.$t('nav.device'), path: '/products/device' },
          ],
        },
        {
          title: this.$t('nav.education'),
          items: [
            { label: this.$t('nav.stem'), path: '/solutions/stem' },
            { label: this.$t('nav.maker'), path: '/solutions/maker' },
          ],
        },
        {
          title: this.$t('nav.software'),
          items: [],
        },
        {
          title: this.$t('nav.service'),
          items: [
            { label: this.$t('nav.afterSale'), path: '/support/after-sale' },
          ],
        },
        {
          title: this.$t('nav.about'),
          items: [
            { label: this.$t('nav.aboutUs'), path: '/about' },
            { label: this.$t('nav.dealer'), path: '/about/dealer' },
            { label: this.$t('nav.cooperation'), path: '/about/cooperation' },
            { label: this.$t('nav.news'), path: '/about/news' },
          ],
        },
      ]
    },
  },
  methods: {
    subscribe() {
      if (!this.subscribeInput) {
        this.$message.warning(this.$t('footer.subscribePlaceholder'))
        return
      }
      this.$message.success(this.$t('footer.subscribeSuccess'))
      this.subscribeInput = ''
    },
    toggleGroup(index) {
      if (!this.isMobile) return
      this.$set(this.openGroups, index, !this.openGroups[index])
    },
    closeAllGroups() {
      this.openGroups = {}
    },
    handleResize() {
      this.windowWidth = window.innerWidth
      if (this.windowWidth > 768) {
        this.closeAllGroups()
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
}
</script>

<style scoped>
/* ============================================
   基础样式 - 完全保持桌面端原样
   ============================================ */
.site-footer {
  background: #fff;
  padding: 40px 0 20px;
  border-top: 1px solid #f0f0f0;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: 1fr 380px;
  gap: 40px;
  align-items: start;
}

/* ===== 导航列 ===== */
.nav-columns {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;
  text-align: left;
}

.nav-title {
  font-size: 18px;
  color: #333;
  margin: 0 0 12px;
  font-weight: normal;
}

.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-item {
  margin: 8px 0;
}

.nav-item a {
  font-size: 16px;
  color: #666;
  text-decoration: none;
  transition: color 0.2s ease;
}

.nav-item a:hover {
  color: #4285F4;
}

/* ===== 联系信息 ===== */
.contact-side {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.contact-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 8px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.contact-item .text {
  font-size: 14px;
  color: #333;
}

.icon {
  width: 18px;
  height: 18px;
  display: inline-block;
  object-fit: contain;
  flex-shrink: 0;
}

/* ===== 订阅 ===== */
.subscribe {
  display: grid;
  grid-template-columns: 1fr 90px;
  gap: 10px;
}

.subscribe-input ::v-deep .el-input__inner {
  height: 36px;
}

.subscribe-btn {
  background: #FBBC05;
  border: none;
  color: #fff;
  border-radius: 12px;
  font-size: 16px;
}

.subscribe-btn:hover {
  background: #f0ac00;
}

/* ===== 社交 ===== */
.social {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.social-item {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}

.social-item:hover {
  transform: translateY(-2px);
}

.social-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

/* ===== 底部 ===== */
.footer-bottom {
  display: flex;
  align-items: center;
  gap: 30px;
  margin-top: 30px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
  flex-wrap: wrap;
}

.logo {
  height: 24px;
}

.icp {
  font-size: 12px;
  color: #999;
}

/* ============================================
   平板端适配 (769px - 1024px)
   ============================================ */
@media (max-width: 1024px) and (min-width: 769px) {
  .footer-content {
    grid-template-columns: 1fr 320px;
    gap: 30px;
  }

  .nav-columns {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }

  .nav-title {
    font-size: 16px;
  }

  .nav-item a {
    font-size: 14px;
  }

  .container {
    padding: 0 16px;
  }
}

/* ============================================
   手机端适配 (<= 768px) - 只修改移动端样式
   ============================================ */
@media (max-width: 768px) {
  .site-footer {
    padding: 30px 0 16px;
  }

  .container {
    padding: 0 12px;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  /* ===== 导航列 - 手机端改为折叠 ===== */
  .nav-columns {
    grid-template-columns: 1fr;
    gap: 0;
  }

  .nav-group {
    border-bottom: 1px solid #f5f5f5;
    padding: 4px 0;
  }

  .nav-title {
    font-size: 16px;
    margin: 0;
    padding: 14px 0;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
  }

  .nav-arrow {
    font-size: 18px;
    color: #999;
    transition: transform 0.3s ease;
    display: inline-block;
  }

  .nav-arrow.open {
    transform: rotate(90deg);
  }

  .nav-list {
    overflow: hidden;
    max-height: 0;
    transition: max-height 0.3s ease;
    padding: 0;
  }

  .nav-list.open {
    max-height: 500px;
    padding: 0 0 12px 0;
  }

  .nav-item {
    margin: 4px 0;
  }

  .nav-item a {
    font-size: 14px;
    padding: 6px 0;
    display: block;
  }

  /* ===== 联系信息 ===== */
  .contact-side {
    gap: 14px;
  }

  .contact-list {
    gap: 6px;
  }

  .contact-item .text {
    font-size: 13px;
  }

  .icon {
    width: 16px;
    height: 16px;
  }

  /* ===== 订阅 ===== */
  .subscribe {
    grid-template-columns: 1fr auto;
    gap: 8px;
  }

  .subscribe-input ::v-deep .el-input__inner {
    height: 34px;
    font-size: 13px;
  }

  .subscribe-btn {
    font-size: 14px;
    padding: 0 16px;
    height: 34px;
    border-radius: 10px;
  }

  /* ===== 社交 ===== */
  .social {
    gap: 10px;
  }

  .social-item {
    width: 28px;
    height: 28px;
  }

  .social-icon {
    width: 20px;
    height: 20px;
  }

  /* ===== 底部 ===== */
  .footer-bottom {
    gap: 16px;
    margin-top: 20px;
    padding-top: 10px;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .logo {
    height: 20px;
  }

  .icp {
    font-size: 11px;
  }
}

/* ============================================
   小屏手机适配 (<= 480px)
   ============================================ */
@media (max-width: 480px) {
  .site-footer {
    padding: 20px 0 12px;
  }

  .container {
    padding: 0 10px;
  }

  .footer-content {
    gap: 20px;
  }

  .nav-title {
    font-size: 15px;
    padding: 12px 0;
  }

  .nav-item a {
    font-size: 13px;
  }

  .subscribe {
    grid-template-columns: 1fr;
    gap: 6px;
  }

  .subscribe-btn {
    width: 100%;
  }

  .social-item {
    width: 24px;
    height: 24px;
  }

  .social-icon {
    width: 18px;
    height: 18px;
  }

  .footer-bottom {
    gap: 10px;
    margin-top: 16px;
  }

  .logo {
    height: 18px;
  }
}

/* ============================================
   横屏手机适配
   ============================================ */
@media (max-width: 768px) and (orientation: landscape) {
  .nav-columns {
    grid-template-columns: repeat(2, 1fr);
    gap: 0 20px;
  }

  .nav-list.open {
    max-height: 300px;
  }
}

/* ============================================
   只在移动端修复溢出问题
   ============================================ */
@media (max-width: 768px) {
  /* ✅ 防止横向溢出 */
  .site-footer,
  .container,
  .footer-content,
  .nav-columns,
  .nav-group,
  .contact-side,
  .subscribe,
  .social,
  .footer-bottom {
    overflow-x: hidden;
  }

  /* ✅ 确保所有元素不超出容器 */
  .site-footer * {
    max-width: 100%;
    box-sizing: border-box;
  }

  /* ✅ 修复 el-input 溢出 */
  .subscribe-input {
    width: 100%;
    min-width: 0;
  }

  .subscribe-input ::v-deep .el-input {
    width: 100%;
  }

  .subscribe-input ::v-deep .el-input__inner {
    width: 100%;
  }

  /* ✅ 长文本换行 */
  .contact-item .text,
  .nav-item a {
    word-break: break-word;
  }

  /* ✅ 移除移动端滚动条 */
  ::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }

  /* ✅ 移除点击高亮 */
  .nav-title,
  .nav-item a,
  .subscribe-btn,
  .social-item {
    -webkit-tap-highlight-color: transparent;
  }
}
</style>